import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Tierliste } from '../gruppe-tier/classes/tierliste';

/** Opens Gruppe auswählen → Import-Optionen after internal Ausstall (Umstallen). */
export interface TierlisteInternalImportHandler {
    open(tierliste: Tierliste): Observable<boolean>;
}

export const TIERLISTE_INTERNAL_IMPORT_HANDLER = new InjectionToken<TierlisteInternalImportHandler>(
    'TIERLISTE_INTERNAL_IMPORT_HANDLER',
);
